import { Component, Input, Output, OnInit, EventEmitter } from "@angular/core";
import { FormArray, FormBuilder, FormGroup, Validators } from "@angular/forms";
import { CustomValidators } from "ngx-custom-validators";
import { NgxSpinnerService } from "ngx-spinner";
import { attachmentsApi } from "src/app/services/constants/api.constants";
import { HelpersService, HttpBaseService } from "@evento-ng/libs";
import { TicketService } from "src/app/services/ticket.service";

@Component({
  selector: "app-custom-form",
  templateUrl: "./custom-form.component.html",
  styleUrls: ["./custom-form.component.scss"],
})
export class CustomFormComponent implements OnInit {
  @Input() customFormDetails: any;
  @Output() backToTickets = new EventEmitter();
  customForm!: FormGroup;
  customFormFields = [];
  file: any;
  constructor(
    private fb: FormBuilder,
    private ticketService: TicketService,
    public helpers: HelpersService,
    private spinner: NgxSpinnerService,
    private dataService: HttpBaseService
  ) {}
  ngOnInit(): void {
    this.initCustomForm();
    this.customForm.valueChanges.subscribe((_) => {
      this.ticketService.updateBookTicket({
        customForm: {
          ...this.customForm.value,
          isValid: this.customForm.valid,
        },
      });
    });
    this.fillValues();
  }

  private initCustomForm(): void {
    this.customForm = this.fb.group({
      values: this.fb.array([]),
    });
  }

  fillCheckboxValues(form: any, ev: any, option: any): void {
    const currentValue = form.value.value?.split(",") || [];

    if (ev.target.checked) {
      currentValue.push(option.id);
    } else {
      const index = currentValue.indexOf(option.id);
      currentValue.splice(index, 1);
    }

    form.patchValue({
      value: currentValue.join(","),
    });
  }

  get valuesArray(): FormArray {
    return this.customForm?.get("values") as FormArray;
  }

  fillValues() {
    const bookTicket = this.ticketService.bookTicket.getValue();
    this.customFormDetails.forEach(
      (
        field: {
          validations: {
            maxLength: number;
            minLength: number;
            min: number;
            max: number;
            minDate: string;
            maxDate: string;
            required: any;
          };
          id: any;
        },
        i: string | number
      ) => {
        const validators = [];

        if (field.validations.maxLength) {
          validators.push(Validators.maxLength(field.validations.maxLength));
        }
        if (field.validations.minLength) {
          validators.push(Validators.minLength(field.validations.minLength));
        }
        if (field.validations.min) {
          validators.push(Validators.min(field.validations.min));
        }
        if (field.validations.max) {
          validators.push(Validators.max(field.validations.max));
        }
        if (field.validations.minDate) {
          validators.push(
            CustomValidators.minDate(field.validations.minDate.split("T")[0])
          );
        }
        if (field.validations.maxDate) {
          validators.push(
            CustomValidators.maxDate(
              this.helpers.formatDateForCustomValidators(
                field.validations.maxDate
              )
            )
          );
        }
        if (field.validations.required) {
          validators.push(Validators.required);
        }
        (this.customForm.get("values") as FormArray).push(
          this.fb.group({
            field: [field.id],
            value: [bookTicket.customForm?.values[i]?.value, [...validators]],
          })
        );
      }
    );
    this.ticketService.updateBookTicket({
      customForm: {
        ...this.customForm.value,
        isValid: this.customForm.valid,
      },
    });
  }

  onFileSelected(event: any, control: any) {
    const input = event.target as HTMLInputElement;
    if (!input.files || input.files.length === 0) {
      return;
    }
    const file = input.files[0];
    this.uploadFile(file, control);
  }

  uploadFile(file: File, control: any) {
    const reader = new FileReader();
    reader.onload = () => {
      this.file = reader.result?.toString() || "";
      this.spinner.show();
      this.dataService
        .post(`${attachmentsApi}/custom-form`, {
          file: this.file,
        })
        .subscribe({
          next: (res) => {
            this.spinner.hide();

            control.patchValue({
              value: res.url,
              file: this.file,
            });

            this.ticketService.updateBookTicket({
              customForm: {
                ...this.customForm.value,
                isValid: this.customForm.valid,
              },
            });
          },
          error: (err) => {
            console.error("Error uploading file:", err);
            this.spinner.hide();
          },
        });
    };

    reader.readAsDataURL(file);
  }

  back() {
    this.backToTickets.emit();
  }
}
